import { Controller } from "@hotwired/stimulus"

// Copy-to-clipboard with a brief "copied!" confirmation on the button.
export default class extends Controller {
  static targets = ["button"]
  static values = { text: String }

  copy() {
    navigator.clipboard.writeText(this.textValue).then(() => {
      const original = this.buttonTarget.textContent
      this.buttonTarget.textContent = "copied!"
      setTimeout(() => { this.buttonTarget.textContent = original }, 1500)
    })
  }
}
